import React from 'react';
import { connect } from 'react-redux'
import { setHiddenWord as setHiddenWordAction } from '../actions'

import '../../scss/WordBlock.scss';

const WordBlock = ({ item, onWordSelect, hiddenWord }) => (
    <div
        className={`wordBlock ${hiddenWord !== item ? "wordBlockVisible" : "wordBlockInvisible"}`}
        onClick={() => hiddenWord !== item ? onWordSelect(item) : onWordSelect("")}
    >
        {hiddenWord !== item ? item : "?"}
    </div>
)

const mapStateToProps = state => ({
    hiddenWord: state.hiddenWordState,
})

const mapDispatchToProps = dispatch => ({
    onWordSelect: hiddenWord => dispatch(setHiddenWordAction(hiddenWord)),
})

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)
(WordBlock);